import axios from 'axios';
import { BASE_URL } from '@/api/constant';
import { clearPortfolioToken, getPortfolioToken } from '@/hooks/portfolio/portfolioTokenStorage';

const isPortfolioLoginRequest = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) {
    return false;
  }
  const requestUrl = error.config?.url ?? '';
  return requestUrl.includes('/portfolio/login');
};

const isPortfolioAccessPath = (pathname: string): boolean => {
  return pathname === '/portfolio' || pathname === '/portfolio/';
};

const portfolioAxiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  transitional: {
    clarifyTimeoutError: true,
  },
});

portfolioAxiosInstance.interceptors.request.use(
  (config) => {
    if (config.url?.includes('/portfolio/login')) {
      return config;
    }
    const token = getPortfolioToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

portfolioAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401 && !isPortfolioLoginRequest(error)) {
      clearPortfolioToken();
      if (!isPortfolioAccessPath(window.location.pathname)) {
        window.location.assign('/portfolio');
      }
    }
    return Promise.reject(error);
  }
);

export default portfolioAxiosInstance;
